import { format } from 'date-fns';
import classNames from 'classnames';
import { Tooltip } from '@chakra-ui/react';

export const columns = [
  {
    header: 'Event Name',
    accessorKey: 'name',
    cell: ({ row }) => {
      const value = row.original;
      return (
        <p className="lg:max-w-[450px] 2xl:w-full lg:whitespace-normal 2xl:whitespace-nowrap">
          {value.name.charAt(0).toUpperCase() + value.name.slice(1)}
        </p>
      );
    },
    sortingFn: 'alphanumeric',
  },
  {
    header: 'Created By',
    accessorKey: 'user',
    cell: ({ getValue }) => {
      const value = getValue();
      return `${value.first_name} ${value.last_name}` || value.email;
    },
    sortingFn: 'alphanumeric',
  },
  {
    header: 'Start Date',
    accessorKey: 'start_date',
    cell: ({ getValue }) => {
      const value = getValue();
      if (!value) return '-';
      try {
        return format(new Date(value), 'MMM d, yyyy h:mm a');
      } catch (error) {
        return '-';
      }
    },
    sortingFn: 'datetime',
  },
  {
    header: 'End Date',
    accessorKey: 'end_date',
    cell: ({ getValue }) => {
      const value = getValue();
      if (!value) return '-';
      try {
        return format(new Date(value), 'MMM d, yyyy h:mm a');
      } catch (error) {
        return '-';
      }
    },
    sortingFn: 'datetime',
  },
  {
    header: 'Status',
    accessorKey: 'status',
    cell: ({ getValue }) => {
      const value = getValue();
      return (
        <span
          className={classNames('px-2 py-1 rounded-full text-sm', {
            'bg-green-100 text-green-800': value === 'public',
            'bg-gray-100 text-gray-800': value === 'hidden',
            'bg-orange-100 text-orange-800': value === 'flagged',
          })}
        >
          {value.charAt(0).toUpperCase() + value.slice(1)}
        </span>
      );
    },
    filterFn: 'equals',
  },
  {
    header: 'RSVP Counts',
    accessorKey: 'rsvp_counts',
    cell: ({ row }) => {
      const value = row.original?.rsvp_counts;
      return (
        <span className="text-gray-600">
          {value.attending || 0} Going · {value.interested || 0} Interested ·{' '}
          {value.not_attending || 0} Not Attending
        </span>
      );
    },
    sortingFn: (rowA, rowB) => {
      // Sort by total RSVP count (going + interested)
      const totalA = rowA.original.going_count + rowA.original.interested_count;
      const totalB = rowB.original.going_count + rowB.original.interested_count;
      return totalA - totalB;
    },
  },
  {
    header: 'Actions',
    accessorKey: 'actions',
    cell: ({ row, onEdit, onDelete, onViewStats, loggedInUserType }) => {
      const event = row.original;
      return (
        <div className="flex items-center space-x-2">
          <Tooltip label="View RSVP statistics" placement="top">
            <button
              onClick={() => onViewStats(event)}
              className="p-2 text-green-600 hover:text-green-800"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z" />
              </svg>
            </button>
          </Tooltip>
          {loggedInUserType === 'admin' && (
            <Tooltip label="Edit event details" placement="top">
              <button
                onClick={() => onEdit(event)}
                className="p-2 text-blue-600 hover:text-blue-800"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                </svg>
              </button>
            </Tooltip>
          )}

          {loggedInUserType === 'admin' && (
            <Tooltip label="Delete this event" placement="top">
              <button
                onClick={() => onDelete(event)}
                className="p-2 text-red-600 hover:text-red-800"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </Tooltip>
          )}
        </div>
      );
    },
  },
];
